const s3StrengthsLabels = {
    fr: {
        p1: "Sens politique",
        p2: "Pensée complexe",
        p3: "Pensée critique",
        p4: "Créativité",
        p5: "Coopération",
        p6: "Initiative",
        p7: "Communication",
        p8: "Leadership",
        p9: "Technophilie",
        p10: "Flexibilité"
    },
    en: {
        p1: "Political sense",
        p2: "Complex thinking",
        p3: "Critical thinking",
        p4: "Creativity",
        p5: "Cooperation",
        p6: "Initiative",
        p7: "Communication",
        p8: "Leadership",
        p9: "Technophilia",
        p10: "Flexibility"
    }
}
export default s3StrengthsLabels
